// extracted by mini-css-extract-plugin
module.exports = {"buttonsWrap":"update-tracking-code-modal_buttonsWrap_1y4T9","button":"update-tracking-code-modal_button_2_B_y"};